export const stylesColors = {
  blue: '#0066CC',
  yellow: 'rgb(255, 128, 0)',
  grey: '#F0F0F0',
  grey2: '#B2B2B2',
  white: '#ffffff',
  black: '#000000',
  light: '#f8f9fa'
}